import type { TExportEventType } from "constants/index";
import type { CsiSystem } from "design-scope";
import type { DesignScopePageView } from "./design-scope-view-meta";

export function designScopeExportEventType(
  format: "CSV" | "EXCEL" | "PDF",
  view: DesignScopePageView,
  treeSystem: CsiSystem
): TExportEventType {
  if (view !== "hierarchy") {
    if (format === "EXCEL") return "DESIGN_SCOPE_LOG_LIST_EXPORT_EXCEL";
    if (format === "PDF") return "DESIGN_SCOPE_LOG_LIST_EXPORT_PDF";
    return "DESIGN_SCOPE_LOG_LIST_EXPORT_CSV";
  }
  if (treeSystem === "MF") {
    return format === "PDF"
      ? "DESIGN_SCOPE_LOG_MASTERFORMAT_EXPORT_PDF"
      : "DESIGN_SCOPE_LOG_MASTERFORMAT_EXPORT_EXCEL";
  }
  return format === "PDF"
    ? "DESIGN_SCOPE_LOG_UNIFORMAT_EXPORT_PDF"
    : "DESIGN_SCOPE_LOG_UNIFORMAT_EXPORT_EXCEL";
}

/** Base name, without extension, used as the print-window title and PDF audit name. */
export function designScopePdfFileBaseName(
  projectName: string | undefined
): string {
  const safe =
    (projectName || "Project")
      .replace(/[\\/:*?"<>|]/g, " ")
      .replace(/\s+/g, " ")
      .trim() || "Project";
  return `Design_Scope_Log_${safe}`;
}
